import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  IReducerTechniciansState,
  FETCH_TECHNICIAN,
  FETCH_TECHNICIANS,
  TechniciansActionTypes,
} from './types';

const initialState: IReducerTechniciansState = {
  all: undefined,
  current: undefined,
};

const persistConfig = {
  storage,
  key: 'technicians',
  whitelist: ['all'],
};

const reducers = (state = initialState, action: TechniciansActionTypes) => {
  switch (action.type) {
    case FETCH_TECHNICIANS:
      return {
        ...state,
        all: action.payload,
      };
    case FETCH_TECHNICIAN:
      return {
        ...state,
        current: action.payload,
      };

    default:
      return state;
  }
};

export default persistReducer(persistConfig, reducers);
